module.exports = __webpack_public_path__ + "img/5eafef5c0efdc2fef815b848f01aedda.png";